import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import { connect, ReactReduxContext } from 'react-redux';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Modal from '../modal/Modal';
import { Loading } from "../state/Loading";
import { Form, Field } from 'formik';
import { FormInput, FormSelect } from '../forms/elements';
import UsStates from '../forms/elements/UsStates'; // import { Debug } from "../forms/Debug";

import { formikEnhancer } from "./formik/formikEnhancer";
import { formatter, mobileAppUtil } from "../../util";
import { accountHelper, apiUtil } from "../../util"; // Redux

import { accountDuck } from "../../ducks/account";
import axios from "axios";
var accountOperations = accountDuck.operations;

var MyAccount = function MyAccount(props) {
  var _props$account2, _props$account2$aadRe, _props$account2$aadRe2;

  var _props$account = props.account,
      account = _props$account === void 0 ? {} : _props$account,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$getAccountAddr = props.getAccountAddress,
      getAccountAddress = _props$getAccountAddr === void 0 ? function () {
    return console.log('get account address');
  } : _props$getAccountAddr,
      _props$postAccountAdd = props.postAccountAddress,
      postAccountAddress = _props$postAccountAdd === void 0 ? function () {
    return console.log('post account address');
  } : _props$postAccountAdd,
      _props$deleteAccountA = props.deleteAccountAddress,
      deleteAccountAddress = _props$deleteAccountA === void 0 ? function () {
    return console.log('delete account address');
  } : _props$deleteAccountA,
      _props$handleProfileE = props.handleProfileEdit,
      handleProfileEdit = _props$handleProfileE === void 0 ? function () {
    return console.log('Handle profile edit');
  } : _props$handleProfileE,
      _props$handlePassword = props.handlePasswordReset,
      handlePasswordReset = _props$handlePassword === void 0 ? function () {
    return console.log('Handle password edit');
  } : _props$handlePassword,
      _props$logout = props.logout,
      logout = _props$logout === void 0 ? function () {} : _props$logout;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      accountInfo = _useState2[0],
      setAccountInfo = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      addresses = _useState4[0],
      setAddresses = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showAddressForm = _useState6[0],
      setShowAddressForm = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      activeAddress = _useState8[0],
      setActiveAddress = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showDeleteAddress = _useState10[0],
      setShowDeleteAddress = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      hasSubmitDeleteRequest = _useState12[0],
      setHasSubmitDeleteRequest = _useState12[1];

  var accountCards = [{
    id: 'personal',
    title: "My Personal Details",
    hasPencil: true,
    topActionCopy: "Edit",
    topAction: function topAction(e) {
      handleProfileEdit(e);
    },
    bodyCopy: ''
  }, {
    id: 'address',
    title: "Addresses",
    hasPencil: false,
    topActionCopy: "Add new address",
    topAction: function topAction(e) {
      setActiveAddress({});
      setShowAddressForm(true);
    },
    bodyCopy: ''
  }, {
    id: 'password',
    title: "Password",
    hasPencil: true,
    topActionCopy: "Update password",
    topAction: function topAction(e) {
      handlePasswordReset(e);
    },
    bodyCopy: '****************'
  }];
  useEffect(function () {
    getAccountAddress();
  }, [(_props$account2 = props.account) === null || _props$account2 === void 0 ? void 0 : (_props$account2$aadRe = _props$account2.aadResponse) === null || _props$account2$aadRe === void 0 ? void 0 : (_props$account2$aadRe2 = _props$account2$aadRe.account) === null || _props$account2$aadRe2 === void 0 ? void 0 : _props$account2$aadRe2.accountIdentifier]);
  useEffect(function () {
    setAccountInfo(props.accountInfo);
  }, [props.accountInfo]);
  useEffect(function () {
    if (props.addresses) {
      setAddresses(props.addresses);
    }
  }, [props.addresses]);

  var deleteAccount = function deleteAccount() {
    var showDelete = mobileAppUtil.isiOS(); // const showDelete = true

    if (showDelete) {
      return /*#__PURE__*/React.createElement("a", {
        className: "",
        style: {
          cursor: 'pointer',
          color: '#94273A'
        },
        onClick: function onClick(e) {
          setHasSubmitDeleteRequest(true);
        }
      }, "Delete Account");
    }

    return null;
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: "cb-account__title"
  }, "My Account"), accountCards.map(function (account) {
    return /*#__PURE__*/React.createElement(AccountCard, _extends({
      isLoading: isLoading,
      accountInfo: accountInfo,
      addresses: addresses,
      showAddressForm: showAddressForm,
      showDeleteAddress: showDeleteAddress,
      setShowAddressForm: setShowAddressForm,
      setShowDeleteAddress: setShowDeleteAddress,
      activeAddress: activeAddress,
      setActiveAddress: setActiveAddress,
      getAccountAddress: getAccountAddress,
      postAccountAddress: postAccountAddress,
      handleDelete: deleteAccountAddress
    }, account));
  }), /*#__PURE__*/React.createElement("hr", null), deleteAccount(), /*#__PURE__*/React.createElement(Modal, {
    className: 'mt-5',
    show: hasSubmitDeleteRequest,
    hide: function hide() {
      setHasSubmitDeleteRequest(false);
    },
    title: "Are you sure?"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-l-margin-xxsmall--bottom"
  }, "Are you sure you want to delete your account?"), /*#__PURE__*/React.createElement("p", {
    className: "cb-l-margin-xxsmall--bottom"
  }, "You can create another account, but won't be able to use the same email address associated with this account."), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary mt-16",
    onClick: function onClick() {
      var userId = accountInfo.sub;
      console.log('Deleting users', userId);
      var apiUrl = apiUtil.generateUrl('aad-b2c-utility-api', 'deleteUser').replace('{userId}', userId);
      axios({
        method: 'delete',
        headers: apiUtil.setHeadersB2C(),
        url: apiUrl
      }).then(function (json) {
        // dispatch(response(json))
        logout();
      }).catch(function (err) {
        // dispatch(error(err));
        alert('Request Failed');
        console.log("Failed to process delete request", err);
      });
    }
  }, "Delete")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-secondary mt-16",
    onClick: function onClick() {
      setHasSubmitDeleteRequest(false);
    }
  }, "Cancel"))))));
};

var AccountCard = function AccountCard(props) {
  var title = props.title,
      hasPencil = props.hasPencil,
      topAction = props.topAction,
      topActionCopy = props.topActionCopy;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__header"
  }, /*#__PURE__*/React.createElement("h3", null, title), topActionCopy ? /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      if (typeof topAction === 'undefined') {
        return false;
      }

      return topAction();
    },
    className: hasPencil ? "cb-account-card__pencil" : "cb-button-primary"
  }, topActionCopy) : null), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__content"
  }, CardBody(props)));
};

var SimpleCard = function SimpleCard(props) {
  var bodyCopy = props.bodyCopy;
  return /*#__PURE__*/React.createElement(RichText, {
    field: {
      value: bodyCopy
    },
    tag: "p"
  });
};

var PersonalInfo = function PersonalInfo(props) {
  var _props$accountInfo = props.accountInfo,
      accountInfo = _props$accountInfo === void 0 ? {} : _props$accountInfo;
  var bodyCopy = props.bodyCopy;

  if (accountInfo.given_name) {
    var fullName = (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.given_name) + ' ' + (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.family_name);
    var email = (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.emails[0]) || '';
    var phone = (accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.extension_MobilePhone) || '';
    bodyCopy = "<p>".concat(fullName, "</p><p>").concat(formatter.phone(phone), "</p><p>").concat(email, "</p>");
  }

  return /*#__PURE__*/React.createElement(RichText, {
    field: {
      value: bodyCopy
    },
    tag: "p"
  });
};

var AddressForm = function AddressForm(props) {
  var _props$addresses = props.addresses,
      addresses = _props$addresses === void 0 ? [] : _props$addresses,
      _props$address = props.address,
      address = _props$address === void 0 ? {} : _props$address,
      _props$setActiveAddre = props.setActiveAddress,
      setActiveAddress = _props$setActiveAddre === void 0 ? function () {
    console.log('Set active address');
  } : _props$setActiveAddre,
      _props$setShowAddress = props.setShowAddressForm,
      setShowAddressForm = _props$setShowAddress === void 0 ? function () {
    console.log('Handle submit');
  } : _props$setShowAddress,
      _props$handleSubmit = props.handleSubmit,
      handleSubmit = _props$handleSubmit === void 0 ? function () {
    console.log('Handle submit');
  } : _props$handleSubmit,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {
    console.log('Set field');
  } : _props$setFieldValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: address.firstName,
    name: "firstName",
    label: "First Name",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      return setFieldValue("firstName", e);
    }
  }), /*#__PURE__*/React.createElement(Field, {
    value: address.lastName,
    name: "lastName",
    label: "Last Name",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      return setFieldValue("lastName", e);
    }
  }), /*#__PURE__*/React.createElement(Field, {
    value: address.address1,
    name: "address1",
    label: "Address",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      return setFieldValue("address1", e);
    }
  }), /*#__PURE__*/React.createElement(Field, {
    value: address.address2,
    name: "address2",
    label: "Building Name / Suite / Apt",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      return setFieldValue("address2", e);
    }
  }), /*#__PURE__*/React.createElement(Field, {
    value: address.city,
    name: "city",
    label: "City",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      return setFieldValue("city", e);
    }
  }), /*#__PURE__*/React.createElement(Field, {
    value: address.state,
    name: "state",
    label: "State",
    hideLabel: true,
    component: FormSelect,
    options: UsStates,
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      setFieldValue("state", e.currentTarget.value);
    }
  }), /*#__PURE__*/React.createElement(Field, {
    value: address.zipCode,
    name: "zipCode",
    label: "Postal Code",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      return setFieldValue("zipCode", e);
    }
  }), /*#__PURE__*/React.createElement(Field, {
    value: address.addressId,
    type: "hidden",
    name: "addressId"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    className: "cb-button-primary"
  }, "Save"), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick(e) {
      setShowAddressForm(false);
      setActiveAddress({});
    },
    className: "cb-button-secondary"
  }, "Cancel")))));
};

var FormikAddressForm = formikEnhancer(AddressForm);

var Address = function Address(props) {
  var _props$isLoading2 = props.isLoading,
      isLoading = _props$isLoading2 === void 0 ? true : _props$isLoading2,
      _props$addresses2 = props.addresses,
      addresses = _props$addresses2 === void 0 ? [] : _props$addresses2,
      _props$showAddressFor = props.showAddressForm,
      showAddressForm = _props$showAddressFor === void 0 ? false : _props$showAddressFor,
      _props$showDeleteAddr = props.showDeleteAddress,
      showDeleteAddress = _props$showDeleteAddr === void 0 ? false : _props$showDeleteAddr,
      _props$setShowAddress2 = props.setShowAddressForm,
      setShowAddressForm = _props$setShowAddress2 === void 0 ? function () {
    console.log('Set show address form');
  } : _props$setShowAddress2,
      _props$activeAddress = props.activeAddress,
      activeAddress = _props$activeAddress === void 0 ? {} : _props$activeAddress,
      _props$setActiveAddre2 = props.setActiveAddress,
      setActiveAddress = _props$setActiveAddre2 === void 0 ? function () {
    console.log('Set active address');
  } : _props$setActiveAddre2,
      _props$getAccountAddr2 = props.getAccountAddress,
      getAccountAddress = _props$getAccountAddr2 === void 0 ? function () {
    console.log('Get account address');
  } : _props$getAccountAddr2,
      _props$postAccountAdd2 = props.postAccountAddress,
      postAccountAddress = _props$postAccountAdd2 === void 0 ? function () {
    console.log('Post account address');
  } : _props$postAccountAdd2,
      _props$setShowDeleteA = props.setShowDeleteAddress,
      setShowDeleteAddress = _props$setShowDeleteA === void 0 ? function () {
    console.log('Delete account address');
  } : _props$setShowDeleteA,
      _props$handleDelete = props.handleDelete,
      handleDelete = _props$handleDelete === void 0 ? function () {
    console.log('Delete account address');
  } : _props$handleDelete;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeleteModal, {
    addresses: addresses,
    activeAddress: activeAddress,
    handleDelete: handleDelete,
    showDeleteAddress: showDeleteAddress,
    setShowDeleteAddress: setShowDeleteAddress
  }), isLoading && /*#__PURE__*/React.createElement("div", {
    className: "cb-l-container-wrapper--space"
  }, /*#__PURE__*/React.createElement(Loading, {
    isLoading: isLoading
  })), !showAddressForm && !isLoading ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, addresses && addresses.map(function (address) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
      lg: "4",
      className: "cb-l-margin-small--bottom"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AddressBlock, {
      address: address
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "cb-l-margin-small--right",
      onClick: function onClick(e) {
        e.preventDefault();
        setActiveAddress(address);
        setShowAddressForm(true);
      }
    }, "Edit"), /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        setActiveAddress(address);
        setShowDeleteAddress(true);
      }
    }, "Delete"))));
  }))) : /*#__PURE__*/React.createElement(FormikAddressForm, {
    addresses: addresses,
    address: activeAddress,
    getAccountAddress: getAccountAddress,
    postAccountAddress: postAccountAddress,
    setShowAddressForm: setShowAddressForm,
    setActiveAddress: setActiveAddress
  }));
};

var CardBody = function CardBody(props) {
  var _props$id = props.id,
      id = _props$id === void 0 ? 'personal' : _props$id;

  switch (id) {
    case 'personal':
      return PersonalInfo(props);

    case 'address':
      return Address(props);

    case 'password':
      return SimpleCard(props);

    default:
      return null;
  }
};

export var AddressBlock = function AddressBlock(props) {
  var _props$address2 = props.address,
      address = _props$address2 === void 0 ? {} : _props$address2;
  return /*#__PURE__*/React.createElement("p", null, address.firstName, " ", address.lastName, " ", /*#__PURE__*/React.createElement("br", null), address.address1, " ", address.address2, " ", /*#__PURE__*/React.createElement("br", null), address.city, " ", address.state, ", ", address.zipCode);
};
export var DeleteModal = function DeleteModal(props) {
  var _props$activeAddress2 = props.activeAddress,
      activeAddress = _props$activeAddress2 === void 0 ? {} : _props$activeAddress2,
      _props$addresses3 = props.addresses,
      addresses = _props$addresses3 === void 0 ? [] : _props$addresses3,
      _props$showDeleteAddr2 = props.showDeleteAddress,
      showDeleteAddress = _props$showDeleteAddr2 === void 0 ? false : _props$showDeleteAddr2,
      _props$setShowDeleteA2 = props.setShowDeleteAddress,
      setShowDeleteAddress = _props$setShowDeleteA2 === void 0 ? function () {
    console.log('Hide delete address');
  } : _props$setShowDeleteA2,
      _props$handleDelete2 = props.handleDelete,
      handleDelete = _props$handleDelete2 === void 0 ? function () {
    console.log('Handle delete address');
  } : _props$handleDelete2;
  return /*#__PURE__*/React.createElement(Modal, {
    show: showDeleteAddress,
    hide: function hide() {
      setShowDeleteAddress(false);
    },
    title: "Are you sure?"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-l-margin-xxsmall--bottom"
  }, "Are you sure you want to delete the following address from your account?"), /*#__PURE__*/React.createElement(AddressBlock, {
    address: activeAddress
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary mt-16",
    onClick: function onClick() {
      setShowDeleteAddress(false);
      handleDelete(activeAddress, addresses);
    }
  }, "Delete")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-secondary mt-16",
    onClick: function onClick() {
      setShowDeleteAddress(false);
    }
  }, "Cancel")))));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$account, _state$account2, _state$account3, _state$account4;

  var accountInfo = accountHelper((_state$account = state.account) === null || _state$account === void 0 ? void 0 : _state$account.aadResponse);
  return {
    accountInfo: accountInfo,
    account: state.account,
    addresses: Array.isArray((_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : _state$account2.addresses) ? _toConsumableArray((_state$account3 = state.account) === null || _state$account3 === void 0 ? void 0 : _state$account3.addresses) : [],
    isLoading: (_state$account4 = state.account) === null || _state$account4 === void 0 ? void 0 : _state$account4.loading,
    isError: state.error.isError,
    err: state.error.err
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getAccountAddress: function getAccountAddress() {
      return dispatch(accountOperations.getAccountAddress());
    },
    postAccountAddress: function postAccountAddress(address, addresses) {
      return dispatch(accountOperations.postAccountAddress(address, addresses));
    },
    deleteAccountAddress: function deleteAccountAddress(address, addresses) {
      return dispatch(accountOperations.deleteAccountAddress(address, addresses));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);